/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 8a727ebdd3804d635229dbcaca01b85d7f53aadb4321ddfc419b8690ce600ff0
 */
import {
  base_colorContentBorder,
  white100,
} from 'ext-ui/style/colors'
import {
  nav_desktop_navContainerItemsVSpacing,
  nav_desktop_navContainerVSpacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  background: ${white100};
  border-color: ${base_colorContentBorder};
  border-right-style: solid;
  border-right-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
  display: flex;
  flex-direction: column;
  gap: ${nav_desktop_navContainerItemsVSpacing};
  padding-block: ${nav_desktop_navContainerVSpacing};
  width: 100%;

  &.not-minimized {
    width: 232px;
  }

  &.minimized {
    width: 40px;
  }

  &.enterprise {
  }

  &.pro {
  }

  &.starter {
  }
`
